var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-create"},[_c('create-report-wizard',{on:{"go-back":_vm.goBack,"created-new-report":_vm.createdNewReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }